<template>
  <div id="dashboard" style="min-height: 650px;">
    <!-- Page Content -->
    <div class="content">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="['btabs-animated-fade-'+item.BIS_TYPE ,
              [bis.length>1&&(item.BIS_TYPE==bisType)?'active':''],
              [bis.length==1?' oneTable':'']]"
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>

          <li class="ml-auto nav-main-item add" v-if="!addSiteBtn&&!addSystem && !addTimeLenBtn"></li>
          <li class="ml-auto nav-main-item add" v-if="addSiteBtn || addSystem||addTimeLenBtn">
            <a
              class="nav-main-link nav-main-link-submenu"
              data-toggle="submenu"
              aria-haspopup="true"
              aria-expanded="false"
              href="#"
            >
              <button type="button" class="btn-block-option add-btn mr-2" data-toggle="modal">
                <i class="fa fa-plus mr-1"></i> 新增
              </button>
            </a>
            <ul class="nav-main-submenu">
              <li
                class="nav-main-item"
                data-toggle="modal"
                v-if="addSiteBtn"
                @click="create('charge')"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">站点</span>
                </a>
              </li>
              <li
                class="nav-main-item"
                data-toggle="modal"
                v-if="addCarportSystem"
                @click="create('carport')"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">车棚</span>
                </a>
              </li>
              <li
                class="nav-main-item"
                data-toggle="modal"
                @click="$router.push({name: 'billRateEdit',params:{id:'add'}})"
                v-if="addSystem"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">充电费率</span>
                </a>
              </li>
              
              <li
                class="nav-main-item"
                data-toggle="modal"
                @click="create('stopRate')"
                v-if="addCarportSystem"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">停车费率</span>
                </a>
              </li>
              <li
                class="nav-main-item"
                data-toggle="modal"
                @click="create('system')"
                v-if="addTimeLenBtn"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">充电包费率</span>
                </a>
              </li>
              <li
                class="nav-main-item"
                data-toggle="modal"
                @click="create('carportSystem')"
                v-if="addCarportSystem"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">停车包费率</span>
                </a>
              </li>
            </ul>
          </li>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div
            class="tab-pane fade show active"
            id="btabs-animated-fade-1"
            role="tabpanel"
            v-show="isFlatcomplexPageTabs"
            :class="{'show active':isFlatcomplexPageTabs }"
          >
            <flatcomplex ref="flatcomplex"></flatcomplex>
          </div>
          <div
            class="tab-pane fade"
            id="btabs-animated-fade-2"
            role="tabpanel"
            v-show="isCarportPageTabs"
            :class="{'show active':!isFlatcomplexPageTabs&& isCarportPageTabs}"
          >
            <allCarport ref="allCarport"></allCarport>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-3" role="tabpanel">
            <chargeRate ref="chargeRate"></chargeRate>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-4" role="tabpanel">
            <stopRate ref="stopRate"></stopRate>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-5" role="tabpanel">
            <system ref="system"></system>
          </div>
          <div class="tab-pane fade" id="btabs-animated-fade-6" role="tabpanel">
            <carportSystem ref="carportSystem"></carportSystem>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增充电站 -->
    <div
      class="modal fade"
      id="modal-default-normal-charge-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-charge-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增站点</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="form.cellId"
                    @change="changeCellId()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                      :label="item.CELL_NAME"
                    ></el-option>
                  </el-select>
                  <!-- <select
                    class="form-control inline-block col-sm-12"
                    v-model="form.cellId"
                    @change="changeCellId()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  站点名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder v-model="form.siteName" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  坐标经度
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.gpsLng" maxlength="16" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  坐标纬度
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.gpsLat" maxlength="16" />
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">联系人姓名</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.cellContactPerson"
                    maxlength="16"
                  />
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">联系人电话</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.cellTelePhone"
                    maxlength="11"
                  />
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">联系人邮箱</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.cellEmail " />
                </div>
              </div>-->
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  最大充电时长
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.maxChargeMinute">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option v-for="(item,index) in 12" :key="index" :value="item">{{item}}小时</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="example-text-input" class="col-sm-12 control-label">
                  智能充电
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="sel-isEnableIntelligent"
                    name="sel-isEnableIntelligent"
                    v-model="form.isEnableIntelligent"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in isEnableIntelligentList"
                      :key="index"
                      :value="item.value"
                    >{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="example-text-input" class="col-sm-12 control-label">
                  时长充电
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.isEnableTimelen">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in isEnableTimelenList"
                      :key="index"
                      :value="item.value"
                    >{{item.name}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label for="example-text-input" class="col-sm-12 control-label">
                  扫码进入
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="sel-scanFlag"
                    name="sel-scanFlag"
                    v-model="form.scanFlag"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in scanFlagList"
                      :key="index"
                      :value="item.value"
                    >{{item.name}}</option>
                  </select>
                </div>
              </div> -->
              
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  仅白名单用户
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.authType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in authTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>

              <!-- <div class="form-group form-group-50">
                <label for="cell-pic" class="col-sm-12 control-label">站点图片</label>
                <div class="col-sm-12">
                  <div class="change-style"></div>
                  <el-upload
                    class="avatar-uploader dz-image-120"
                    :action="actionUrl"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handlePreview"
                  >
                    <img v-if="form.imgStr" :src="form.imgStr" style="width:100%;" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div class="col-sm-12"></div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('charge')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增充电包费率 -->
    <div
      class="modal fade"
      id="modal-default-normal-system"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-system"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增充电包费率</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model=" form.cellId"
                    @change="cellNameSel()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                      :label="item.CELL_NAME"
                    ></el-option>
                  </el-select>
                  <!-- <select
                    class="form-control"
                    style="display:inline-block;"
                    v-model=" form.cellId"
                    @change="cellNameSel()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  站点名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" id="siteId" name="siteId" v-model=" form.siteId">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in siteList"
                      :key="index"
                      :value="item.SITE_ID"
                    >{{item.SITE_NAME}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  时长包类型
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model=" form.packageType" @change="chengType()">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packgeType"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  有效时长
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.duration"
                    maxlength="16"
                    @blur="durationBlur()"
                    placeholder="小时"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  时长包名
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.customName"
                    placeholder="请输入"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  有效月数
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model=" form.validMonth"
                    :disabled="form.packageType==1||form.packageType==3"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 13"
                      :key="index"
                      :value="index+'' "
                    >{{ index==0?'本月月底失效':index==1?'次月月底失效':index+'个月后月底失效'}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  有效天数
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model=" form.validTime"
                    maxlength="16"
                    placeholder="天"
                    :disabled="form.packageType=='2' "
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">
                  价格(元)
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model=" form.payMoney"
                    :placeholder="form.packageType==3?'默认免费':'元'"
                    :disabled="form.packageType==3"
                    maxlength="16"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">每日限制时长</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model=" form.limit_duration">
                    <option selected="selected" disabled="disabled" value>无限制</option>
                    <option v-for="(item,index) in 25" :key="index" :value="item-1">{{item-1}}小时</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">每日重置时间</label>
                <div class="col-sm-12">
                  <select class="form-control" v-model=" form.reset_hour">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in 24"
                      :key="index"
                      :value="index>9?index + ':00':'0'+index+':00'"
                    >{{index>9?index + ':00':'0'+index+':00'}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group form-group-50">
                <label for="cell-auth-type" class="col-sm-12 control-label">
                  仅白名单用户
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.big_package_type">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in yesOrNo"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('system')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增车棚 -->
    <div
      class="modal fade"
      id="modal-default-normal-carport-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-carport-add"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增车棚</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  小区名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="form.cellId"
                    @change="changeCellId()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :data="item"
                      :value="item.CELL_ID"
                      :label="item.CELL_NAME"
                    ></el-option>
                  </el-select>
                  <!-- <select
                    class="form-control col-sm-12"
                    v-model="form.cellId"
                    @change="changeCellId()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input class="form-control" placeholder v-model="form.carportName" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  坐标经度
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.gpsLng" maxlength="16" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  坐标纬度
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.gpsLat" maxlength="16" />
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label for="cell-type" class="col-sm-12 control-label">联系人姓名</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" maxlength="16" v-model="form.contacts" />
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label for="cell-nature" class="col-sm-12 control-label">联系人电话</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" maxlength="16" v-model="form.mobile" />
                </div>
              </div>-->
              <!-- <div class="form-group form-group-50">
                <label   class="col-sm-12 control-label">联系人邮箱</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.email" />
                </div>
              </div>-->
              <div class="form-group form-group-50">
                <label for="example-text-input" class="col-sm-12 control-label">
                  扫码进入
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="sel-scanFlag"
                    name="sel-scanFlag"
                    v-model="form.scanFlag"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in scanFlagList"
                      :key="index"
                      :value="item.value"
                    >{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  仅白名单用户
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.whileListType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in authTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label for="cell-pic" class="col-sm-12 control-label">车棚图片</label>
                <div class="col-sm-12">
                  <el-upload
                    class="avatar-uploader dz-image-120"
                    :action="actionUrl"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handlePreview"
                  >
                    <img v-if="form.thumbnallUrl" :src="form.thumbnallUrl" style="width:100%;" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div class="col-sm-12"></div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('carport')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增停车费率 -->
    <div
      class="modal fade"
      id="modal-default-normal-stopRate"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-stopRate"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增停车费率</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">小区名称</label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="cell"
                    @change="getDistrictCode()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                      :label="item.CELL_NAME"
                    ></el-option>
                  </el-select>
                  <!-- <select
                    class="form-control"
                    style="display:inline-block;"
                    v-model="cell"
                    @change="getDistrictCode()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                    >{{item.CELL_NAME}}</option>
                  </select>-->
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    v-model="form.carportId"
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  费率类型
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.billingType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in billingTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div> -->
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">预扣押金(元)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    placeholder="默认免费"
                    v-model="form.withholdingDeposit"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">临停车费(元/日)</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.cost"
                    placeholder="默认免费"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('stopRate')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 停车包费率 -->
    <div
      class="modal fade"
      id="modal-default-normal-carportSystem"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-carportSystem"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增停车包费率</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">小区名称</label>
                <div class="col-sm-12">
                  <el-select
                    filterable
                    placeholder="请输入"
                    style="width: 100%;"
                    v-model="form.cellId"
                    @change="getDistrictCode()"
                  >
                    <el-option
                      v-for="(item,index) in cellList"
                      :key="index"
                      :value="item.CELL_ID"
                      :label="item.CELL_NAME"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    @change="changeCarport()"
                    v-model="form.carportId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  车辆类型
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    v-model="form.carTypeId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in carTypeList"
                      :key="item.CAR_TYPE_ID"
                      :label="item.CAR_TYPE_NAME"
                      :value="item.CAR_TYPE_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  时长包类型
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="form.packageType"
                    @change="changeValIdType()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in packageTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  有效时长
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.valIdTime">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option value="0">每日</option>
                    <option v-for="(item,index) in 12" :key="index" :value="item">{{item}}个月</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  时长包名
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.packageName" maxlength="16" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  叠加充电包
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="chargePackageId"
                    name="chargePackageId"
                    v-model="form.chargePackageId"
                    :disabled=" form.chargePackageId=='0'"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in chargePackageIdList"
                      :key="index"
                      :value="item.PACKAGE_ID"
                    >{{item.DESCRIPTION}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  价格(元)
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.payMoney" maxlength="16" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">副标题</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.subTitle" maxlength="16" />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">标签</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.label" maxlength="16" />
                </div>
              </div>
              <div class="form-group  form-group-50">
                <label class="col-sm-12 control-label">
                  仅白名单用户
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.authType">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in authTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit('carportSystem')"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../Util.js";
import flatcomplex from "../buildingPoint/flatcomplex";
import allCarport from "../buildingPoint/allCarport";
import chargeRate from "../billRate/chargeRate";
import system from "../package/systemPackage/system";
import stopRate from "../billRate/stopRate";
import carportSystem from "../package/systemPackage/carportSystem";

export default {
  name: "index",
  components: {
    flatcomplex,
    allCarport,
    chargeRate,
    system,
    stopRate,
    carportSystem
  },
  data() {
    return {
      oldBis: [
        {
          BIS_TYPE: "1",
          BIS_NAME: "站点",
          SHOW_TAB: Util.isPageTabsPerm("flatcomplexList")
        },
        {
          BIS_TYPE: "2",
          BIS_NAME: "车棚",
          SHOW_TAB: Util.isPageTabsPerm("allCarport")
        },
        {
          BIS_TYPE: "3",
          BIS_NAME: "充电费率",
          SHOW_TAB: Util.isPageTabsPerm("flatcomplexList")
        },
        {
          BIS_TYPE: "4",
          BIS_NAME: "停车费率",
          SHOW_TAB: Util.isPageTabsPerm("allCarport")
        },
        {
          BIS_TYPE: "5",
          BIS_NAME: "充电包费率",
          SHOW_TAB: Util.isPageTabsPerm("flatcomplexList")
        },
        {
          BIS_TYPE: "6",
          BIS_NAME: "停车包费率",
          SHOW_TAB: Util.isPageTabsPerm("allCarport")
        }
      ],
      isFlatcomplexPageTabs: Util.isPageTabsPerm("flatcomplexList"),
      isCarportPageTabs: Util.isPageTabsPerm("allCarport"),
      bis: [],
      bisType: 1,
      authTypeList: [
        {
          value: 0,
          label: "否"
        },
        {
          value: 1,
          label: "是"
        }
      ],
      yesOrNo: [
        {
          value: "2",
          label: "是"
        },
        {
          value: "0",
          label: "否"
        }
      ],
      packgeType: [
        {
          value: "1",
          label: "普通"
        },
        {
          value: "2",
          label: "月底清零"
        },
        {
          value: "3",
          label: "车棚叠加包"
        }
      ],
      scanFlagList: [
        {
          value: 0,
          name: "不允许"
        },
        {
          value: 1,
          name: "允许"
        }
      ],
      isEnableIntelligentList: [
        {
          value: 0,
          name: "不允许"
        },
        {
          value: 1,
          name: "允许"
        }
      ],
      isEnableTimelenList: [
        {
          value: 0,
          name: "不允许"
        },
        {
          value: 1,
          name: "允许"
        }
      ],
      siteList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      carportList: [],
      carTypeList: [],
      chargePackageIdList: [],
      pro: "",
      city: "",
      dis: "",
      cell: "",
      actionUrl: Util.operateURL + "/picture/pictureUpload",
      headers: {
        Accept: "application/json, text/plain, */*",
        token_key: Util.getCookie("token_key")
      },
      form: {
        siteName: "",
        gpsLng: "",
        cellAddress: "",
        maxChargeMinute: "",
        nature: "",
        imgStr: "",
        cellType: "",
        cellTelePhone: "",
        cellContactPerson: "",
        cellEmail: "",
        siteId: "",
        carportName: "",
        carportLocation: "",
        gpsLat: "",
        cellId: "",
        contacts: "",
        mobile: "",
        email: "",
        thumbnallUrl: "",
        id: "",
        carportId: "",
        whileListType: 0,
        authType: 0,
        cellDistrictCode: "",
        packageType: "",
        duration: "",
        customName: "",
        validMonth: "",
        validTime: "",
        payMoney: "",
        limit_duration: "",
        reset_hour: "",
        scanFlag: "",
        isEnableIntelligent: "",
        isEnableTimelen: "",
        big_package_type: 0
      },
      billingTypeList: [
        {
          value: 2,
          label: "临时停车"
        }
      ],
      packageTypeList: [
        {
          value: "0",
          label: "停车"
        },
        {
          value: "1",
          label: "停车+充电"
        }
      ],
      addSiteBtn: Util.isHavePerm("cellBase/addStieInfo"),
      addSystem: Util.isHavePerm("rateManagement/addRate"),
      addTimeLenBtn: Util.isHavePerm("timeLen/addTimeLen"),
      addCarportSystem: Util.isHavePerm("carPort/insertCarportCarRate")
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    }
  },
  watch: {
    "form.validTime"(val, oldVal) {
      this.form.validTime = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.payMoney"(val, oldVal) {
      if (!val) return;
      this.form.payMoney = Util.testNumberFn(val, "inputChangeTwoDecimal");
    },
    "form.limit_duration"(val, oldVal) {
      this.form.limit_duration = Util.testNumberFn(val, "inputChangeNoDecimal");
    },
    "form.duration"(val, oldVal) {
      if (this.edit == "system") {
        this.form.duration = Util.testNumberFn(val, "inputChangeNoDecimal");
      }
    }
  },
  mounted() {
    this.oldBis.find(item => {
      if (item.SHOW_TAB) {
        this.bis.push(item);
      }
    });
    if (this.$route.params.id == "carport") {
      this.showTab("btabs-animated-fade-2", 2);
    } else if (this.$route.params.id == "billRateEdit") {
      this.showTab("btabs-animated-fade-3", 3);
    }
  },
  methods: {
    getCellInfo() {
      this.$http.get(`${Util.searchURL}/FlatComplex/SearchBy/?key=`).then(
        res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              this.cellList = res.data.data;
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeValIdType() {
      if (this.form.packageType == 0) {
        this.form.chargePackageId = "0";
      } else {
        this.form.chargePackageId = "";
      }
    },
    changeCarport() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/SearchByChargePackage/${this.form.carportId}`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.chargePackageIdList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    create(val) {
      this.edit = val;
      $(".btabs-animated-fade-" + this.bisType)[0].className =
        "nav-link active btabs-animated-fade-" + this.bisType;
      if (val == "charge") {
        jQuery("#modal-default-normal-charge-add").modal("show");
      } else if (val == "system") {
        jQuery("#modal-default-normal-system").modal("show");
      } else if (val == "carport") {
        jQuery("#modal-default-normal-carport-add").modal("show");
      } else if (val == "carportSystem") {
        jQuery("#modal-default-normal-carportSystem").modal("show");
        this.searchCarType();
        this.searchCarport();
      } else if (val == "stopRate") {
        jQuery("#modal-default-normal-stopRate").modal("show");
        this.searchCarport();
      }
      this.getCellInfo();

      this.pro = "";
      this.city = "";
      this.dis = "";
      this.cityList = [];
      this.districtList = [];
      // this.cellList = [];
      this.siteList = [];
      this.form = {
        siteName: "",
        gpsLng: "",
        cellAddress: "",
        maxChargeMinute: "",
        nature: "",
        imgStr: "",
        cellType: "",
        cellTelePhone: "",
        cellContactPerson: "",
        cellEmail: "",
        siteId: "",
        carportName: "",
        carportLocation: "",
        gpsLat: "",
        cellId: "",
        contacts: "",
        mobile: "",
        email: "",
        thumbnallUrl: "",
        id: "",
        carportId: "",
        whileListType: 0,
        authType: 0,
        packageType: "",
        duration: "",
        customName: "",
        validMonth: "",
        validTime: "",
        payMoney: "",
        limit_duration: "",
        reset_hour: "",
        scanFlag: "",
        isEnableIntelligent: "",
        isEnableTimelen: "",
        big_package_type: 0
      };
    },
    submit(val) {
      let url = "";
      if (val == "charge") {
        url = `${Util.operateURL}/cellBase/addStieInfo`;
      } else if (val == "system") {
        if (this.form.packageType == 3) {
          this.form.payMoney = 0;
        }
        url = `${Util.operateURL}/timeLen/addTimeLen`;
        if (!this.form.cellId) {
          Util.message("err", "请选择小区名称");
          return;
        }
        this.form.cellDistrictCode = this.form.cellId.substr(0, 6);
      }
      if (val == "carport") {
        url = `${Util.operateURL}/carPortInfo/insertCarPortInfo`;
      } else if (val == "carportSystem") {
        url = `${Util.operateURL}/carPort/insertCarportCarRate`;
      } else if (val == "stopRate") {
        url = `${Util.operateURL}/carPort/insertCarportStopRate`;
      }

      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);

            jQuery("#modal-default-normal-charge-add").modal("hide");
            jQuery("#modal-default-normal-system").modal("hide");
            jQuery("#modal-default-normal-carport-add").modal("hide");
            jQuery("#modal-default-normal-carportSystem").modal("hide");
            jQuery("#modal-default-normal-stopRate").modal("hide");
            if (val == "charge") {
              this.showTab("btabs-animated-fade-1", 1);
            } else if (val == "carport") {
              this.showTab("btabs-animated-fade-2", 2);
            } else if (val == "system") {
              this.showTab("btabs-animated-fade-4", 4);
            } else if (val == "stopRate") {
              this.showTab("btabs-animated-fade-5", 5);
            } else if (val == "carportSystem") {
              this.showTab("btabs-animated-fade-6", 6);
            }
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchCarType() {
      this.$http.get(`${Util.searchURL}/Carport/SearchByCarType?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carTypeList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    searchPackge() {
      if (this.form.carportId == "") return;
      this.$http
        .get(
          `${Util.searchURL}/Carport/SearchByChargePackage/${this.form.carportId}?key=`
        )
        .then(
          res => {
            if (res.data.code === 200) {
              this.packageList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    getDistrictCode() {
      if (!this.dis && !this.city && !this.cell) {
        this.code = this.pro;
      }
      if (!this.dis && this.city && !this.cell) {
        this.code = this.city;
      }
      if (this.dis && !this.cell) {
        this.code = this.dis;
      }
      if (this.cell) {
        this.code = this.cell;
      }
      this.$http
        .post(`${Util.searchURL}/Carport/ListByCarportByCode/${this.code}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.carportList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    cellNameSel() {
      let cellId = this.form.cellId;
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListBySiteByCell/${cellId}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.siteList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    changeCellId() {
      for (let i in this.cellList) {
        if (this.cellList[i].CELL_ID == this.form.cellId) {
          this.form.siteName = this.cellList[i].CELL_NAME + "充电站";
          this.form.carportName = this.cellList[i].CELL_NAME + "小区智能车棚";
          this.form.gpsLat = this.cellList[i].GPS_LAT;
          this.form.gpsLng = this.cellList[i].GPS_LNG;
        }
      }
    },
    chengType() {
      if (this.form.packageType == "1") {
        this.form.validMonth = "";
      } else if (this.form.packageType == "2") {
        this.form.validTime = "";
      } else if (this.form.packageType == "3") {
        this.form.payMoney = "";
        this.form.validMonth = "";
      }
    },
    durationBlur() {
      if (this.form.duration && !this.form.customName) {
        this.form.customName = this.form.duration + "小时";
      }
    },
    handlePreview(res) {
      if (res.code == 200) {
        this.form.thumbnallUrl = res.data.url;
        this.form.imgStr = res.data.url;
        Util.message("succ", "上传成功");
      } else if (res.code === 4412) {
        Util.message("err", res.desc);
      } else {
        Util.message("err", res.desc);
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },

    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.flatcomplex.getList();
      } else if (type == 2) {
        this.$refs.allCarport.getList();
      } else if (type == 3) {
        this.$refs.chargeRate.getList();
      } else if (type == 4) {
        this.$refs.system.getList();
      } else if (type == 5) {
        this.$refs.stopRate.getList();
      } else if (type == 6) {
        this.$refs.carportSystem.getList();
      }
    }
  }
};
</script>
